// import React, { useEffect, useState } from "react";
import React from "react";

// import { analytics, db, auth, app } from "./firebase";
// import { collection, getDocs } from "firebase/firestore";

import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Scheduling from "./components/Scheduling";
import PayBill from "./components/PayBill";
import MonitoringContract from "./components/MonitoringContract";
import Home from "./components/Home";
import 'bootstrap/dist/css/bootstrap.min.css';
import MyNavBar from "./components/MyNavbar";
import About from "./components/About";
import FireAlarmTools from "./components/FireAlarmTools";

function App() {
  // const [data, setData] = useState([]);
  // useEffect(() => {
  //   if (analytics) {
  //   analytics.logEvent('page_view')
  //   }

  // }, []);
  return (
    <div className="App">

    <Router>
        <MyNavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/scheduling" element={<Scheduling />} />
          <Route path="/pay-bill" element={<PayBill />} />
          <Route path="/monitoring-contract" element={<MonitoringContract />} />
          <Route path="/fire-alarm-tools" element={<FireAlarmTools />} />
        </Routes>

    </Router>
    </div>

  );
}

export default App;